import React from 'react';
import { SEND_INVITE } from '../../services/companies';
import { GET_ALL_PROFILES } from '../../services/profiles';
import { GET_ALL_TEAMS } from '../../services/teams';
import { InputFieldTypes } from '../input_field';
import ModalForm from '../modal_form';
import { CREATE_USER, GET_USER_DATA, UPDATE_USER } from '../../services/users';
import { showNotification } from '@mantine/notifications';
import { Text } from '@mantine/core';
import { useAuth } from '../../contexts/auth.context';

export default function Create({open = true, onClose, onSave, id = null, data: prevData = null }){
    const [formData, setFormData] = React.useState<any>(null);
    const [loadingData, setLoadingData] = React.useState(false);
    const [loadingSave, setLoadingSave] = React.useState(false);
    const [error, setError] = React.useState<any>(null);
    const [profiles, setProfiles] = React.useState<any[]>([]);
    const [teams, setTeams] = React.useState<any[]>([]);

    const { currentCompany } = useAuth();

    const loadProfiles = () => {
        GET_ALL_PROFILES()
        .then(res => {
            console.log(res)
            setProfiles(res)
        })
        .catch(err => {})
    }
    
    const loadTeams = () => {
        GET_ALL_TEAMS()
        .then(res => {
            console.log(res)
            setTeams(res)
        })
        .catch(err => {})
    }
    
    const onConfirm = () => {
        setError(null)
        setLoadingSave(true)
        
        if(id){
            UPDATE_USER(id, {...formData})
            .then(res => {
                setLoadingSave(false)
                onSave && onSave()
            })
            .catch(err => {
                setLoadingSave(false)
                setError(err.message)
            })
        }else{
            CREATE_USER({...formData})
            .then(res => {
                setLoadingSave(false)
                onSave && onSave()
            })
            .catch(err => {
                setLoadingSave(false)
                setError(err.message)
            })
        }
    }

    const COLUMNS = [
        id ? null : {title: "Tipo de cadastro", clearable: false, value: formData?.type ?? "email", name: 'type', fieldType: InputFieldTypes.SELECT, options: [
            { value: "email", label: "E-mail" },
            currentCompany?.company?.label ? { value: "id", label: "ID de Usuário" } : null,
        ].filter(nn => nn)},
        {title: "Nome", name: 'name' },
        id ? null : {
            title: formData?.type === "id" ? "ID de Usuário" : "E-mail *",
            name: 'email',
            rightSection: formData?.type === "id" && <Text size="xs" style={{marginLeft: -200}}>@{currentCompany?.company?.label}</Text>,
            type: InputFieldTypes.STRING
        },
        {title: "Telefone", name: 'phone' },
        {title: "Perfil *", name: 'profile', fieldType: InputFieldTypes.SELECT, options: profiles.map(p => ({label: p.title, value: p._id}))},
        (!id && formData?.type === "id") ? {title: "Senha", name: 'password', type: "password" } : null,
    ].filter(nn => nn)

    React.useEffect(() => {
        loadProfiles();
        loadTeams();
    }, [])
    
    React.useEffect(() => {
        setFormData(fd => ({...fd, ...prevData}))
    }, [prevData])

    React.useEffect(() => {
        if(id){
            setLoadingData(true)
            GET_USER_DATA(id)
            .then((dt) => {
                setLoadingData(false)
                setFormData(fd => ({
                    ...fd,
                    name: dt.name,
                    email: dt.email,
                    phone: dt.phone,
                    profile: (dt.roles ?? [])[0]?.profile?._id,
                    teams: dt.teams,
                    data: dt.data
                }))
            })
            .catch(err => {
                setLoadingData(false)
                showNotification({title: "Ops", message: err.message, color: 'red'})
            })
        }else{
            setFormData({});
        }
    }, [id]);

    return <ModalForm
        title={id ? "Editar usuário" : "Inserir usuário"}
        columns={COLUMNS}
        loading={loadingSave}
        error={error}
        onChangeData={(dt) => setFormData(fd => ({...fd, ...dt}))}
        formData={formData}
        open={open}
        onConfirm={onConfirm}
        onClose={onClose}
    />
}